// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1TTZv","question":"Question_question__OJxwW","description":"Question_description__T7d4Y"};